(ns ui.data.account.sub
  (:require [common.modules :as modules]
            [re-frame.core :as rf]
            [ui.data.tenant.sub :as tenant-sub]))

(rf/reg-sub
 ::role
 (fn [db]
   (get db ::role)))

(rf/reg-sub
 ::is-admin?
 :<-
 [::role]
 (fn [role _]
   (some #{role} [:role/admin :role/zadmin :role/sys-admin])))

(rf/reg-sub
 ::account
 (fn [db]
   (get db ::account)))

(rf/reg-sub
 ::account-current-permissions
 :<-
 [::account]
 (fn [account _]
   (:account/current-permissions account)))

(rf/reg-sub
 ::account-modules
 :<-
 [::account-current-permissions]
 :<-
 [::tenant-sub/tenant-modules]
 :<-
 [::is-admin?]
 (fn [[account-current-permissions tenant-modules is-admin?] _]
   (->> modules/modules
        (keep (fn [module]
                (let [has-access? (and (some #{module} tenant-modules)
                                       (or is-admin?
                                           (some #{module} (:account-modules account-current-permissions))))]
                  (when has-access?
                    module))))
        (set)
        (seq))))

